<div *ngIf="showSpinner">
    <div class="spinner-container"></div>
    <p-progressSpinner strokeWidth="5" class="spinner"></p-progressSpinner>
</div>
<header class="header">
    <div class="header-left">
        <span>
            <a class="sidebar-toggle"><img src="../../../assets/images/hamburger-icon.svg"> </a>
        </span>
        <div class="logo ml-3">
            <a href=""><img src="../../../assets/images/logo.png" alt="logo"></a>
        </div>
    </div>
    <div *ngIf="developmentTitle != ''" class="header-center">
        <div class="development-text">
            {{developmentTitle}}
        </div>
    </div>
    <div *ngIf="impersonating">
        <div class="impersonate-text">
            Viewing as <strong>{{username}}</strong>
            <p-dropdown
                *ngIf="!isStaging"
                [options]="employeesList"
                placeholder="View as"
                [group]="true"
                [filter]="true"
                filterBy="label"
                optionLabel="label"
                optionValue="value"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                (onChange)="impersonate($event.value)"
                [panelStyle]="{'min-width':'350px','max-width':'500px'}">
            </p-dropdown>
            <i class="p-message-close-icon pi pi-times mt-1" (click)="clearImpersonate()"></i>
        </div>
    </div>
    <div style="width: 350px;" *ngIf="(canImpersonate || impersonating) && isStaging">
        <p-dropdown
            [options]="employeesList"
            placeholder="View as"
            [group]="true"
            [filter]="true"
            filterBy="label"
            optionLabel="label"
            optionValue="value"
            [virtualScroll]="true"
            [virtualScrollItemSize]="38"
            (onChange)="impersonate($event.value)"
            [panelStyle]="{'min-width':'350px','max-width':'500px'}">
        </p-dropdown>
    </div>
    <div class="header-right">
        <div class="welcome-text text-right">
            Welcome <br> <strong>{{username}}</strong>
        </div>
        <span *ngIf="canAddUniversalNote">
            <a class="universal-note-icon" title="New Note" (click)="universalNote.open()">
                <i class="pi pi-file-edit"></i>
            </a>
        </span>
        <span>
            <a class="logout" (click)="logout()"><img src="../../../assets/images/logout-icon.svg"></a>
        </span>
        <p-confirmDialog header="Logout" icon="pi pi-exclamation-triangle"></p-confirmDialog>
    </div>
</header>
<app-universal-note #universalNote></app-universal-note>